<template>
    <div>
        <div class="header-placeholder"></div>
        <k-container background="bg-white" class="fixed w-full top-0 z-20 shadow-sm">
            <nav class="py-4">
                <div class="flex items-center flex-wrap" style="min-height: 29px;">
                    <div class="flex-grow mr-4">
                        <a :href="landingUrl">
                            <img src="/img/kilde_logo.png" style="max-width: 114px;">
                        </a>
                    </div>
                    <div class="block lg:hidden">
                        <button class="flex items-center px-3 py-2 border rounded text-gray-800 border-gray-800"
                                v-on:click="toggleMenu()">
                            <svg class="fill-current  h-4 w-4" viewBox="0 0 20 20"
                                 xmlns="http://www.w3.org/2000/svg">
                                <title>
                                    Menu</title>
                                <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/>
                            </svg>
                        </button>
                    </div>
                    <div class="text-sm font-base leading-tight lg:flex flex-col lg:flex-row w-full lg:w-auto"
                         :class="itemsVisible ? 'flex' :'hidden'">
                        <template v-for="item in items">
                            <a
                                class="block self-center whitespace-no-wrap hover:text-primary-500 px-4 py-4 relative"
                                exact
                                :href="item.href"
                                v-bind:key="item.href"
                            >
                                <span class="elipse block bg-cover"></span>{{ item.title }}
                            </a>
                        </template>
                        <router-link class="block self-center md:ml-4 py-4" to="/"
                                     v-if="!$root.$authToken()">
                            <k-button class="hidden lg:block" size="sm" :block="true">{{ $t("logIn")}}</k-button>
                            <k-button class="lg:hidden" size="md" :block="true">{{ $t("logIn")}}</k-button>
                        </router-link>
                        <router-link class="block self-center md:ml-4 py-4" :to="'dashboard'"
                                     v-if="$root.$authToken()">
                            <k-button class="hidden lg:block" size="sm" :block="true">{{ $t("dashboard") }}</k-button>
                            <k-button class="lg:hidden" size="md" :block="true">{{ $t("dashboard") }}</k-button>
                        </router-link>
                    </div>
                </div>
            </nav>
        </k-container>
    </div>
</template>

<script>
export default {
    data() {
        return {
            itemsVisible: false,
            items: [],
            landingUrl: null
        }
    },
    methods: {
        toggleMenu() {
            this.itemsVisible = !this.itemsVisible
        }
    },
    mounted() {
        this.landingUrl = process.env.VUE_APP_KILDE_LENDING_BASE_URL
        this.items = [
            {title: 'Home', href: this.landingUrl},
            {title: 'Borrowers', href: this.landingUrl + 'borrowers'},
            {title: 'About', href: this.landingUrl + 'about-us'},
            {title: 'FAQ', href: this.landingUrl + 'faq'},
            {title: 'Insights', href: this.landingUrl + 'insights'}
        ]
    }
}
</script>

<style scoped>
.router-link-exact-active, .router-link-active {
    @apply text-primary-500
}

.router-link-exact-active, .router-link-active .elipse {
    display: block;
}

.header-placeholder {
    height: 66px;
}

@media only screen and (min-width: 1024px) {
    .header-placeholder {
        height: 89px;
    }
}

.elipse {
    display: none;
    position: absolute;
    top: 40px;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: url('/img/elipse-blue.svg');
    background-repeat: no-repeat;
    background-size: contain;
    width: 20px;
    margin: 0 auto;
}
</style>

